module.exports = __webpack_public_path__ + "static/media/Capacidad_baja.c8dc3061.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/contentassets/Capacidad_baja.svg
// module id = 145
// module chunks = 0